import { render, staticRenderFns } from "./RecoveryPassword.vue?vue&type=template&id=f77a8488&"
import script from "./RecoveryPassword.vue?vue&type=script&lang=js&"
export * from "./RecoveryPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports